import { Component, OnInit } from '@angular/core';
import { ParentChildService } from '../../../../../components/parentchild/parentchild.service';
import { ConfirmationService } from 'primeng/primeng';
import { LocalStorageService } from 'ng2-webstorage';
import { MessageService } from 'primeng/components/common/messageservice';
import { DataAnalyticsService } from '../../../../../components/dataAnalytics/dataAnalytics.service';
@Component({
  selector: 'registrationSQ',
  templateUrl: 'registrationSQ.component.html',
  styleUrls: ['registrationSQ.component.scss']
})

export class RegistrationSQComponent implements OnInit {
  public schoolId: any;
  display = "none"
  public info:boolean=false;
  //public userId: any;


  public SchoolYear: any;
  public selectedYear: string = '';


  public HigherEdchildcourse: any;
  public HigherEdchildBatch: any;
  public selectedCourse: string = '';
  public ShowLevelData: any;
  public selectedlevel: string = '';
  public grade: any = [];
  public section: any;
  public selectedgrade:  any;
  public selectedsection:  any;


 



  public selectedbatch: string = '';
  public studentfname: string = '';
  public studentmname: string = '';
  public studentlname: string = '';
  public studentdob: string = '';
  public studentnic: string = '';
  public studentemail: string = '';
  
  //public Genderid: number;
  public studentgender: string = '';


  public studentphone: string = '';
  public studentcreateddate: Date = new Date();
  public studentModifieddate: Date = new Date();
  public stucreatedby: string = ''
  public stumodifiedby: string = ''
  public stustatusid: any =1;
  public studentcode: string = '';

  public SelectedAcademicYearId: any;
  public Selectedregisterationnumber: string = '';
  public SelectedParentFirstname: string = '';
  public SelectedParentLastname: string = '';
  public SelectedParentMiddlename: string = '';
  public SelectedParentDob:  Date = new Date();
  public SelectedParentPhonenumber: string = '';
  public SelectedParentGenderid: string = '';
  public SelectedParentEmailid: string = '';
  public SelectedParentPassword: string = '';

  public SelectedParentIshigheduser:  string = '';
  public SelectedParentIssmsuser:  string = '';


 
  constructor(private messageService: MessageService, private dataAnalyticsservice: DataAnalyticsService, private parentchildservice: ParentChildService,private confirmationService: ConfirmationService, private localStorage: LocalStorageService) 
  {
    this.schoolId = this.localStorage.retrieve('schoolid');
    //this.userId = this.localStorage.retrieve('CurrentChildId');
  }

  ngOnInit() { 
    this.getAcademicYear();

  }

//-------------------------------YEAR----------------------------------------------------------------
private getAcademicYear(){
  this.dataAnalyticsservice.getAcadamicYearOfyears().finally(() => { }).subscribe(
    response => {
      this.SchoolYear = response['yearList'];
      try {
        this.selectedYear =  this.SchoolYear[0].YearId;
        this.getLevelsName()
      } catch (error) {
        
      }
      console.log('yearList',this.SchoolYear)
    },
    error => {
      this.SchoolYear = [];
      console.error(error);
    });
};

changeYear() {
  console.log("courseT",this.selectedYear)
  this.getLevelsName();
 };

//------------------LEVEL Primary, secondary----------------------------------------------------------------
private getLevelsName() {
  this.dataAnalyticsservice
    .getLevel()
    ._finally(() => {})
    .subscribe((response) => {
      this.ShowLevelData = response;
      try {
        this.selectedlevel =  this.ShowLevelData[0].Id;
        this.GetGrade()

      } catch (error) {
        
      }
      console.log("ShowLevelData", this.ShowLevelData);
    });
}

changelevel() {
  console.log("selectedlevel222",this.selectedlevel)
 this.GetGrade();

 };



//------------------------Ex Grade 1,2,3, & A,B,C--------------------------------------------------------------

private GetGrade(){
  this.dataAnalyticsservice.getGradeLevel(this.selectedlevel).finally(() => { }).subscribe(
    response => {
      this.grade = response;
      try {
        this.selectedgrade =  this.grade[0].standardId;
      } catch (error) {
        
      }
      console.log('grade',this.grade)
    },
    error => {
      this.grade = [];
      console.error(error);
      console.log('grade',this.grade)
    });
    

};

changegrade() {
  
  console.log("selectedgrade",this.selectedgrade)

};
changesection(){
  console.log(this.selectedsection)
}

//--------------------------------------------------------------------------------------

 postStudentInfo() {
  //this.Genderid = parseInt(this.studentgender, 10);

  var payload = {
    
      Code: this.studentcode,
      Firstname: this.studentfname,
      Lastname: this.studentlname,
      Middlename: this.studentmname,
      Dob: this.studentdob,
      Phonenumber: this.studentphone,
      Genderid: this.studentgender,
      Createddate: this.studentcreateddate,
      Modifieddate: this.studentModifieddate,
      Createdby: /*this.stucreatedby*/this.schoolId,
      Modifiedby: /*this.stumodifiedby*/this.schoolId,
      Statusid: this.stustatusid,
      Email: this.studentemail,
      Nic: this.studentnic,
      StandardsectionmappingId: this.selectedgrade,
      AcademicYearId: this.selectedYear,
      registerationnumber: this.Selectedregisterationnumber,
      ParentFirstname: this.SelectedParentFirstname,
      ParentLastname: this.SelectedParentLastname,
      ParentMiddlename: this.SelectedParentMiddlename,
      ParentDob: this.SelectedParentDob,
      ParentPhonenumber: this.SelectedParentPhonenumber,
      ParentGenderid: this.SelectedParentGenderid,
      ParentEmailid: this.SelectedParentEmailid,
      ParentPassword: this.SelectedParentPassword,
      ParentIssmsuser: this.SelectedParentIssmsuser == "true" ? true: false,
      ParentIshigheduser: this.SelectedParentIshigheduser == "true" ? true: false,
  };
  
  
  console.log("postStudentInfo",payload);
  
  this.parentchildservice
  .postHiEduChildandTeacherInfo(payload)
  .finally(() => {})
  .subscribe(
    (response) => {
      this.messageService.add({
        severity: "success",
        summary: "Talkative Parents",
        detail: "Student Added Successfully",
      });
      this.display = "none";
      //this.ShowCourse();
      this.clearFormData();

      console.log(response);
    },
    (error) => {}
  );
};

clearFormData() {
  this.selectedCourse ='';
  this.studentcode = '';
  this.studentfname = '';
  this.studentlname = '';
  this.studentmname = '';
  this.studentdob = '';
  this.studentphone = '';
  this.studentgender = '';
  this.studentcreateddate = new Date();
  this.studentModifieddate = new Date();
  this.studentemail = '';
  this.studentnic = '';
  this.Selectedregisterationnumber = '';
  this.SelectedParentFirstname = '';
  this.SelectedParentLastname = '';
  this.SelectedParentMiddlename = '';
  this.SelectedParentDob  = new Date();
  this.SelectedParentPhonenumber = '';
  this.SelectedParentGenderid = '';
  this.SelectedParentEmailid = '';
  this.SelectedParentPassword = '';
  this.SelectedParentIssmsuser = '';
  this.SelectedParentIshigheduser = '';
}

 //----------------------------------------------------------------------------------------------

roleinfo(){
  this.info=true;
 }


editSemsub(semsub){
 
    
     // this.display = true;
     this.display = "block";
   }
 


addSemsub() {

 this.display= "block"
 // this.display = true;
}
onCloseHandled() {
 this.display= "none";
}

}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/parentchild/studentregSQ/registrationSQ.component.ts